export const camelize = string => {
  const stringParts = string.split(" ");
  const finalString = stringParts
    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
    .join("");
  return finalString;
};
